/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobResource {
    getFixupPrototypeFunction() { return TemplateJobResource.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobResource>): TemplateJobResource {
        let obj = Object.assign(new TemplateJobResource(), model);
        TemplateJobResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobResource>): TemplateJobResource {
        if (!model) return null;
        return TemplateJobResource.newInstance(<TemplateJobResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobResource) {
        if (!obj) return;

        models.TemplateJobResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobResource): boolean {
        Object.setPrototypeOf(obj, TemplateJobResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Unique Resource ID.
     */
    resource_id: string;

    /**
     * Name of the resource.
     */
    resource_name: string;

    /**
     * Type of the resource created.
     */
    resource_type: string;

    /**
     * Provides status of the resource.
     */
    status: models.TemplateJobStatus;

    /**
     * Provides reason for the failure of the job
     */
    status_reason: string;

    /**
     * Template job start time.
     */
    start_date: Date;

    /**
     * Template job end time.
     */
    end_date: Date;

}
